export enum ReceiptStatusEnum {
  ACTIVE = 'ACTIVE',
  PARTNER_IN_PROCESS = 'PARTNER_IN_PROCESS',
}
